import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, RemoverResponsavel } from './types';

export const INITIAL_STATE: RemoverResponsavel = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): RemoverResponsavel {
	return produce(state, draft => {
		switch (action.type) {
			case Types.REMOVER_RESPONSAVEL_REQUEST: {
				break;
			}
			case Types.REMOVER_RESPONSAVEL_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}
			case Types.REMOVER_RESPONSAVEL_FAILURE: {
				draft.status = 400;
				break;
			}
			case Types.REMOVER_RESPONSAVEL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
